module.exports = __webpack_public_path__ + "static/media/max-logo.cdf0652e.png";